export default function key_to_title(key: string) {
  const first_letter = key.charAt(0).toLocaleUpperCase(), // 第一個字母改成大寫
    replace_underscore = (key: string) => ` ${key.charAt(1).toLocaleUpperCase()}`, // 底線改成空格，底線後面的第一個字母也改成大寫
    replaced_title = key
      .substr(1)
      .toLocaleLowerCase()
      .replace(/(-([a-z])|(_([a-z])))/g, replace_underscore)
      .trim(), // 去掉第一字母，執行取代的動作
    title = `${first_letter}${replaced_title}`; // 合併成新的 title
  return title;
}
